import * as React from "react";
import { ListBoxProps, ListBoxRenderProps } from "./list-box";
import { CollectionItem, CollectionSection } from "../collections";

// TODO: Decide if we want to keep doing this
// This allows us to use components like Select and Menu withour having to constantly import Items and Section components.

/**
 * This is a helper function to conditionally render children using the default render function API by react-aria.
 */
export function renderListBoxContent<T>({
  children,
  renderOption,
  valueKey,
  sectionKey,
  renderSectionLabel,
  labelKey,
  items,
  defaultItems,
}: ListBoxProps<T> & { defaultItems?: T[] }) {
  const hasChildren = React.Children.count(children) > 0;

  if (hasChildren || typeof children === "function") {
    return children;
  }

  if (items || defaultItems) {
    // eslint-disable-next-line react/display-name
    return (item: T) => {
      const label = (item as any)?.[labelKey ?? "label"];
      const value = (item as any)?.[valueKey ?? "id" ?? "key" ?? "value"];
      const sectionChildren = (item as any)?.[sectionKey ?? "children"] ?? [];

      if ((item as any)?.[sectionKey]) {
        return (
          <CollectionSection
            items={sectionChildren}
            key={value}
            title={renderSectionLabel?.(item)}
          >
            {(item) => {
              return (
                <CollectionItem
                  textValue={(item as any)?.[labelKey ?? "label"]}
                  key={(item as any)?.[valueKey ?? "id" ?? "key" ?? "value"]}
                >
                  {renderOption?.(item as T) ??
                    (item as any)?.[labelKey ?? "label"]}
                </CollectionItem>
              );
            }}
          </CollectionSection>
        );
      }

      return (
        <CollectionItem aria-label={label} textValue={label} key={value}>
          {renderOption?.(item) ?? label}
        </CollectionItem>
      );
    };
  }
}

export function useListBoxContent<T>(props: ListBoxRenderProps<T>) {
  return renderListBoxContent<T>(props);
}
